<template>
  <div class="case_detail">
    <div class="banner" v-if="isMobile" :style="{backgroundImage:`url(${case_data.mbanner || case_data.banner})`}">
        <h1>行业案例</h1>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
    <div class="banner" v-else :style="{backgroundImage:`url(${case_data.banner})`}">
        <h1>行业案例</h1>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">生态合作</button>
            <button @click="goToContact(3)" class="inner-ri">联系我们</button>
         </div>
    </div>
    <div class="case_main">
      <div class="case_title">
        <h1>{{ case_data.name }}</h1>
      </div>
      <div class="content" v-html="case_data.context"></div>
    </div>
  </div>
</template>

<script setup name="caseDetail">
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { getCaseDetail } from '@/api/case'
import { useRoute } from 'vue-router'
const route = useRoute()
const id = ref(route.query.id)
const case_data = ref({})
onMounted(() => {
  window.scrollTo(0, 0)
  checkMobile()
  window.addEventListener('resize', checkMobile)
  caserender()
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
watch(() => route.query.id, (newId) => {
  if (newId) {
    id.value = newId
    window.scrollTo(0, 0)
    caserender()
  }
})
const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 1024
}
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
async function caserender() {
  const res = await getCaseDetail(id.value)
  case_data.value = res.data
}
</script>

<style scoped>
.case_detail {
  width: 100%;
}
.banner {
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  background-color: #ddd;
  margin-bottom: 4em;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner_btn {
  margin-left: 18%;
  font-size: 0.8em;
}
.inner-le, .inner-ri {
  width: 10em;
  height: 2.2em;
  border-radius: 1.5em;
  font-size: 1em;
  border: transparent;
  cursor: pointer;
  margin: 1em auto;
}
.inner-le {
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri {
  background-color: skyblue;
  color: white;
}
.banner h1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 65%;
  margin-top: 1em;
  margin-left: 18%;
  color: white;
  font-size: 22px;
  font-weight: 600;
}
.case_main {
  width: 60%;
  margin: 2em auto;
}
.case_main .case_title {
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
}
.case_main .case_title h1 {
  margin-bottom: 0.5em;
}
.case_main .case_desc {
  color: #666;
  font-size: 0.95em;
}
:deep(.content) {
  line-height: 1.8em;
  font-size: 15px;
}
:deep(.content img) {
  max-width: 100%;
  height: auto;
}
:deep(.content p) {
  margin: 0.5em 0;
}
:deep(.content h1),
:deep(.content h2),
:deep(.content h3),
:deep(.content h4) {
  margin: 1em 0 0.5em;
}
@media (max-width: 1024px) {
  .banner {
    height: 11em;
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1 {
    font-size: 1.2em;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }
  .inner_btn {
    margin-left: 0;
  }
  .inner-le, .inner-ri {
    font-size: 0.8em;
    height: 2.5em;
    margin: 0.5em auto;
  }
  .case_main {
    width: 90%;
  }
}
</style>
